import React, {useEffect, useState} from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button
} from 'reactstrap'

function formatValue(value) {
  if (!value) return undefined;
  if (Array.isArray(value)) {
    if (value.length === 0) {
      return undefined;
    }
    return value.join(" ").toUpperCase();
  }
  return isNaN(value) ? value.toUpperCase() : value;
}

const largeCharThreshold = 200

const CompanyPanel = (props) => {
  const [full, setFull] = useState(false)
  const [large, setLarge] = useState(false)

  let {companyId, source} = props
  let {
    companyName,
    companyContactName,
    // yearIncorporated,
    description,
    round,
    employees,
    fundingAmountCurrency,
    securityTypes,
    // companyId,
    // allowMessages,
    // source
  } = source;
  
  if (!description) {
    description = ''
  }

  function onClick(companyId, source) {
    props.onClick(companyId, source)
  }

  function showMore() {
    setFull(true)
  }

  function showLess() {
    setFull(false)
  }

  useEffect(() => {
    if (description.length && (description.length > largeCharThreshold)) {
      setLarge(true)
    } else {
      setLarge(false)
    }  
  }, [description])

  const showRound = formatValue(round);
  // const showYearIncorporated = formatValue(yearIncorporated)
  const showEmployees = formatValue(employees);
  const showFundingAmountCurrency = formatValue(fundingAmountCurrency);
  const showSecurityTypes = formatValue(securityTypes);
  const allowMessages = source.allowUnsolicitedMessages === 'yes' || false

  let showDescription = description
  if (large && !full) {
    const words = description.split(/\s/)
    let cc = 0
    let lastWordIndex = 0;
    for (;lastWordIndex < words.length; ++lastWordIndex) {
      cc += words[lastWordIndex].length+1
      if (cc > largeCharThreshold) {
        break
      }
    }
    showDescription = words.slice(0, lastWordIndex).join(' ')
  }

  if (!companyId) {
    return <Card style={{border: 'none'}}/>
  }
  return (
    <Card style={{boxShadow: '2px 2px'}}>
      <CardBody>
        <CardTitle style={{fontWeight: 'bolder'}}>{companyName}</CardTitle>
        {allowMessages &&
          <Button size='sm' onClick={() => onClick(companyId, source)}>Message</Button>
        }
        <CardText>
          {companyContactName && `Contact: ${companyContactName}`}
        </CardText>
        <CardText>
          {showDescription}
          <br/>
          {!full && <span onClick={showMore} style={{fontWeight: 'bold', cursor: 'default'}}> more...</span>}
          {full && <span onClick={showLess} style={{fontWeight: 'bold', cursor: 'default'}}> ...less</span>}
        </CardText>
        {full && <CardText>
          {showEmployees && <>Interest Employees: {showEmployees}<br/></>}
          {showRound && <>Interest Round: {showRound}<br/></>}
          {showFundingAmountCurrency && <>Interest Offering: {showFundingAmountCurrency}<br/></>}
          {showSecurityTypes && <>Interest: {showSecurityTypes}<br/></>}
        </CardText>
        }
        {/* {showEmployees && <CardText>Interest Employees: {showEmployees}</CardText>}
        {showRound && <CardText>Interest Round: {showRound}</CardText>}
        {showFundingAmountCurrency && <CardText>Interest Offering: {showFundingAmountCurrency}</CardText>}
        {showSecurityTypes && <CardText>Interest: {showSecurityTypes}</CardText>} */}
        {/* <CardText><pre>{ JSON.stringify(props, null, 2) }</pre></CardText> */}
      </CardBody>
    </Card>
  );
};
export default CompanyPanel;
